import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Card,
  CardBody,
  Table,
} from "reactstrap";

const ViewCustomerModal = ({ show, toggle, customer }) => {
  if (!customer) return null;

  return (
    <Modal isOpen={show} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>Customer Details</ModalHeader>
      <ModalBody>
        <Card className="shadow-sm border-0 mb-3">
          <CardBody>
            <h5 className="fw-bold mb-3 text-primary">General Information</h5>
            <Row className="gy-2">
              <Col md={6}>
                <strong>Name:</strong> {customer.name}
              </Col>
              <Col md={6}>
                <strong>Email:</strong> {customer.email}
              </Col>
              <Col md={6}>
                <strong>Mobile No:</strong> {customer.mobileNo}
              </Col>
              <Col md={6}>
                <strong>State:</strong> {customer.state}
              </Col>
              <Col md={12}>
                <strong>Address:</strong> {customer.address}
              </Col>
              <Col md={6}>
                <strong>GST No:</strong> {customer.gstnNo || "-"}
              </Col>
              <Col md={6}>
                <strong>PAN No:</strong> {customer.panNo || "-"}
              </Col>
              <Col md={6}>
                <strong>Credit Days:</strong> {customer.creditDays || 0}
              </Col>
              <Col md={6}>
                <strong>Credit Limit:</strong> ₹{customer.creditLimit || 0}
              </Col>
              <Col md={6}>
                <strong>Active:</strong>{" "}
                {customer.active ? (
                  <span className="badge bg-success">Active</span>
                ) : (
                  <span className="badge bg-danger">Inactive</span>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card className="shadow-sm border-0 mb-3">
          <CardBody>
            <h5 className="fw-bold mb-3 text-primary">Bank Information</h5>
            <Row className="gy-2">
              <Col md={6}>
                <strong>Bank Name:</strong> {customer.bankName || "-"}
              </Col>
              <Col md={6}>
                <strong>Branch:</strong> {customer.branchName || "-"}
              </Col>
              <Col md={6}>
                <strong>Account No:</strong> {customer.accountNo || "-"}
              </Col>
              <Col md={6}>
                <strong>IFSC Code:</strong> {customer.ifscCode || "-"}
              </Col>
            </Row>
          </CardBody>
        </Card>

        {customer.addressDtos?.length > 0 && (
          <Card className="shadow-sm border-0 mb-3">
            <CardBody>
              <h5 className="fw-bold mb-3 text-primary">
                Additional Addresses
              </h5>
              <Table bordered responsive>
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Address</th>
                  </tr>
                </thead>
                <tbody>
                  {customer.addressDtos.map((addr, index) => (
                    <tr key={addr.id}>
                      <td>{index + 1}</td>
                      <td>{addr.address}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        )}

        {customer.contactPersonDtos?.length > 0 && (
          <Card className="shadow-sm border-0">
            <CardBody>
              <h5 className="fw-bold mb-3 text-primary">Contact Persons</h5>
              <Table bordered responsive>
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile No</th>
                  </tr>
                </thead>
                <tbody>
                  {customer.contactPersonDtos.map((contact, index) => (
                    <tr key={contact.id}>
                      <td>{index + 1}</td>
                      <td>{contact.name}</td>
                      <td>{contact.email}</td>
                      <td>{contact.mobileNo}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ViewCustomerModal;
